import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import { CONSTANTS } from "../cubeComponent/constants/globalVariable";
import axiosWrapper from "../services/axiosWrapper";
import { setCompanyDetails } from "../reducers/companyDetails";
import { portalCompaniesUrl } from "@Services/dataManager";
import type {
  GetCompanyDetailsRequest,
  UpdateCompanyDetailsRequest,
  CompaniesControllerRequest,
  GetCompanyDetailsExtendedResponse,
  UpdateCompanyDetailsResponse,
  CompaniesControllerResponse,
  CompanyDocument,
} from "@ServerTypes/companies/companies.schema";
import type { Exact } from "@Helpers/types/exact";

export type { CompanyDocument };

export const getCompanyData = async <T extends Exact<GetCompanyDetailsRequest, T>>(data: T) => {
  return await axiosWrapper.post<GetCompanyDetailsExtendedResponse>(
    `${getBackendUrl()}/companies/getCompanyDetails`,
    data,
  );
};

export function getCompanyDetails<T extends Exact<GetCompanyDetailsRequest, T>>(data: T) {
  return async (dispatch: AppDispatch) => {
    const response = await getCompanyData(data);
    const companyData = (response.data as any).data;
    dispatch(
      setCompanyDetails({
        ...companyData,
        logoUrl: getUrlForImage({ id: companyData._id }, CONSTANTS.ORGANIZATION),
      }),
    );
  };
}

export async function updateCompanyDetails<T extends Exact<UpdateCompanyDetailsRequest, T>>(data: T) {
  return await axiosWrapper.post<UpdateCompanyDetailsResponse>(
    `${getBackendUrl()}/companies/updateCompanyDetails`,
    data,
  );
}

// Dispatch to the dedicated per-action company endpoints (split from the old companiesController dispatcher).
const COMPANY_ACTION_PATHS: Record<string, string> = {
  insert: `${getBackendUrl()}/companies/insertCompany`,
  update: `${getBackendUrl()}/companies/updateCompany`,
  delete: `${getBackendUrl()}/companies/deleteCompany`,
};

export const portalCompaniesController = async <T extends Exact<CompaniesControllerRequest, T>>(payload: T) => {
  const action = (payload as CompaniesControllerRequest & { action?: string }).action;
  const url = (action && COMPANY_ACTION_PATHS[action]) || portalCompaniesUrl;
  return await axiosWrapper.post<CompaniesControllerResponse>(url, payload);
};
